import {LOAD_SUCCESS} from '../actions/metaData';

export default function reducer(state = {}, action = {}) {
    if (action.type == LOAD_SUCCESS) {
        return {
            ...state,
            entries: action.result.page_metadata
        };
    }

    return state;
}


// WEBPACK FOOTER //
// ./modules/Common/reducers/metaData.js